import { jsx as t, jsxs as c } from "react/jsx-runtime";
import "react";
import { getMinutesFromStr as m, classes as r } from "../../utils/helpers.js";
import { determineIfShowIsOnNow as _ } from "../../utils/date-helpers.js";
import { AirDateFormatter as g } from "../AirDateFormatter/AirDateFormatter.js";
import { ImageCard as u } from "../ImageCard/ImageCard.js";
import { Concat as b } from "../Concat/Concat.js";
import { StringList as h } from "../StringList/StringList.js";
import '../../assets/UpcomingList.css';const e = {
  "upcoming-list": "_upcoming-list_15byb_1",
  "upcoming-list__item": "_upcoming-list__item_15byb_6",
  "upcoming-list__airdate": "_upcoming-list__airdate_15byb_16"
};
function T({ list: l, handleClicks: d = () => !0 }) {
  return /* @__PURE__ */ t("ul", { className: e["upcoming-list"], children: l.length > 0 && l.map((i) => {
    var a, n, s, p;
    const o = m(i.title.element_length);
    return /* @__PURE__ */ c("li", { className: r([e["upcoming-list__item"], "upcoming-list__item"]), children: [
      /* @__PURE__ */ t("div", { className: r([e["upcoming-list__airdate"], "upcoming-list__airdate"]), children: /* @__PURE__ */ c("div", { className: r([e["upcoming-list__airdate-bg"], "upcoming-list__airdate-bg"]), children: [
        _(i.airdate, i.title.element_length) && /* @__PURE__ */ t("div", { className: "upcoming-list__on-now", children: "On Now" }),
        /* @__PURE__ */ t(
          g,
          {
            airdateStr: i.airdate,
            separatorType: "line-break"
          }
        )
      ] }) }),
      /* @__PURE__ */ t(
        u,
        {
          id: i.id,
          image: {
            url: i.title.image.url,
            altText: "",
            aspectRatio: 330 / 185
          },
          title: "",
          content: /* @__PURE__ */ t(b, { list: [
            `<div>EP ${i.title.episode_number}: ${i.title.name}</div><div>${i.title.synopsis}</div>`,
            /* @__PURE__ */ t(h, { list: (n = (a = i.title) == null ? void 0 : a.video) != null && n.brightcove_id ? [o, i.title.rating, "&nbsp;"] : [o, i.title.rating], separatorType: "pipe" })
          ] }),
          cta: (p = (s = i.title) == null ? void 0 : s.video) != null && p.brightcove_id ? {
            label: "Watch Episode",
            type: "play-video",
            href: "",
            relatedResourceId: i.title.video.brightcove_id,
            position: "inline"
          } : {},
          clampContentLines: !1,
          displayInline: !0,
          handleClicks: d
        }
      )
    ] }, `upcoming-list-${i.id}`);
  }) });
}
export {
  T as UpcomingList,
  T as default
};
